import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cliente, User } from 'src/app/models/models';
import { Ativacao, VendedorInfo } from '../../../models/models';
import { SecurityService } from './../../../services/security.service';
import { FirebaseRequestsService } from '../../../services/requests/firebase/firebase-requests.service';

@Component({
  selector: 'app-pesquisa-cliente',
  templateUrl: './pesquisa-cliente.component.html',
  styleUrls: ['./pesquisa-cliente.component.scss'],
})
export class PesquisaClienteComponent implements OnInit {
  cliente: Cliente = null;
  clientes: Cliente[] = [];
  searchFormCpf: FormGroup;
  searchFormCnpj: FormGroup;
  searchFormTelefone: FormGroup;
  error = null;
  user: User;
  telefoneMask = '(00) 0000-00009';
  ativacao!: Ativacao;
  
  vendedorInfo: VendedorInfo | null = null;
  
  constructor(
    private afs: AngularFirestore,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private securityService: SecurityService,
    private fireReqs: FirebaseRequestsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.searchFormCpf = this.fb.group({
      cpf: ['', Validators.required],
    });
    this.searchFormCnpj = this.fb.group({
      cnpj: ['', Validators.required],
    });
    this.searchFormTelefone = this.fb.group({
      telefone: ['', Validators.required],
    });
    this.user = this.securityService.currentUserValue;
    this.fireReqs.obterVendedorAtual().subscribe((info) => {
      this.vendedorInfo = info; // Atualiza a variável quando os dados chegam
    });
    this.searchFormTelefone
      .get('telefone')
      .valueChanges.subscribe((res: string) => {
        if (res.length > 10) {
          this.telefoneMask = '(00) 00000-0000';
        } else {
          this.telefoneMask = '(00) 0000-00009';
        }
      });

    const cpfParam = this.route.snapshot.paramMap.get('cpf');
    if (cpfParam) {
      this.searchFormCpf.controls['cpf'].setValue(cpfParam);
      this.buscarClientePorCpf();
    }
  }

  resetPage(finalizouAtivacao: boolean) {
    if (finalizouAtivacao) {
      this.cliente = null;
      this.searchFormCpf.reset();
      this.searchFormTelefone.reset();
    }
  }

  buscarClientePorCpf() {
    this.error = null;
    this.clientes = [];
    this.cliente = null;

    if (this.searchFormCpf.valid) {
      this.spinner.show();
      this.securityService
        .updateUserRefs2(
          this.securityService.currentUserValue.email,
          this.searchFormCpf.value.cpf,
          null,
          false
        )
        .then((res) => {
          if (res?.next_client?.app_martech_info_cliente) {
            this.cliente = res?.next_client
              ?.app_martech_info_cliente as Cliente;
            this.ativacao = res?.next_client?.ativacao as Ativacao;
          } else {
            this.error = 'Cliente não encontrado';
          }
          this.searchFormCpf.controls['cpf'].setValue('');
          this.spinner.hide();
        });
    }
  }

  buscarClientePorCnpj() {
    this.error = null;
    this.clientes = [];
    this.cliente = null;

    if (this.searchFormCnpj.valid) {
      this.spinner.show();
      this.securityService
        .updateUserRefs2(
          this.securityService.currentUserValue.email,
          this.searchFormCnpj.value.cnpj,
          null,
          false
        )
        .then((res) => {
          if (res?.next_client?.app_martech_info_cliente) {
            this.cliente = res?.next_client
              ?.app_martech_info_cliente as Cliente;
            this.ativacao = res?.next_client?.ativacao as Ativacao;
          } else {
            this.error = 'Cliente não encontrado';
          }
          this.searchFormCnpj.controls['cpf'].setValue('');
          this.spinner.hide();
        });
    }
  }

  buscarClientePorTelefone() {
    this.error = null;
    this.cliente = null;
    this.clientes = [];
    if (this.searchFormTelefone.valid) {
      this.spinner.show();
      this.securityService
        .updateUserRefs2(
          this.securityService.currentUserValue.email,
          null,
          this.searchFormTelefone.value.telefone,
          false
        )
        .then((res) => {
          if (res?.next_client?.app_martech_info_cliente) {
            this.cliente = res?.next_client
              ?.app_martech_info_cliente as Cliente;
            this.ativacao = res?.next_client?.ativacao as Ativacao;
          } else {
            this.error = 'Cliente não encontrado';
          }
          this.searchFormTelefone.controls['telefone'].setValue('');
          this.spinner.hide();
        });
    }
  }
}
